<template>
  <el-row class="mx-5">
    <el-col>
      <el-card shadow="never">
        <PageHeader 
          slot="header" 
          @onCreate="onCreate" 
        />

        <el-dialog
          :title="link && link.id ? 'Editar link' : 'Cadastrar link'"
          :visible.sync="registering"
          fullscreen
          center
        >
          <Register
            v-if="registering"
            @onSave="getLinks(filters); onCancel()"
            @cancel="onCancel()"
          />
        </el-dialog>

        <FilterList v-model="search" />

        <List @changed="getLinks(filters); onCancel()">
          <template slot-scope="{row}">
            <el-button-group>
              <el-button
                v-if="permissions.includes('update-link')"
                size="mini"
                icon="el-icon-edit"
                @click="onEdit(row)"
              >
                Editar
              </el-button>
            </el-button-group>
          </template>
        </List>
        <div class="d-flex justify-content-center p-2">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="meta.total"
            :current-page.sync="meta.current_page"
          />
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>

import List from "@/admin/Pages/link/components/List"
import Register from "@/admin/Pages/link/components/Register"
import FilterList from "@/admin/Pages/link/components/FilterList"
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {defaultLoadingConfig} from "@/admin/constants/general"

export default{
    components: {
        List,
        Register,
        FilterList,
    },
    data() {
        return {
          registering: false,
          showing: false,
          search: '',
          meta : {
              current_page: 1,
              total: 10
          },
        }
    },
    computed:{
      ...mapGetters(['permissions','link']),
      filters(){
        return `${this.search}&page=${this.meta.current_page}`
      }
    },
    watch:{
      filters: {
        handler(){
            clearTimeout(this._timerId)
            this._timerId = setTimeout(() => {
                this.$loading(defaultLoadingConfig);
            this.getLinks(this.filters)
                .then((r)=> {
                    this.meta = r.data.meta;
                }).finally(()=>this.$loading().close())
            }, 500)
        },
        immediate: true,
      },
    },
    
    methods:{
        ...mapActions(['getLinks']),
        ...mapMutations(['SET_LINK']),
        onEdit(page){
          this.registering = true;
          this.SET_LINK(page)
        },
        onCreate(){
            this.SET_LINK({
              title: '',
              url: '',
              module_id: '',
              trail_id: '',
              description: '',
            });
            this.registering = true;
        },
        onCancel(){
            this.registering = false;
            this.SET_LINK(null);
        },
    },
}
</script>
